import React from 'react';
import { Link } from 'react-router-dom';
const Sidebar = () => (
    <div id="sidebar">
        <div id="sidebar-brand" className="themed-background">
            <a href="index.html" className="sidebar-title">
                <i className="fa fa-cube"></i>
                <span className="sidebar-nav-mini-hide">
                    THE
                    <strong>LINK</strong>
                </span>
            </a>
        </div>
        <div id="sidebar-scroll">
            <div className="sidebar-content">
                <ul className="sidebar-nav">
                    <li>
                        <Link to="/dashboard">
                            <i className="gi gi-compass sidebar-nav-icon"></i>
                            <span className="sidebar-nav-mini-hide">Dashboard</span>
                        </Link>
                    </li>
                    <li className="sidebar-separator">
                        <i className="fa fa-ellipsis-h"></i>
                    </li>
                    <li>
                        <Link to="/user-accounts">
                            <i className="gi gi-user sidebar-nav-icon"></i>
                            <span className="sidebar-nav-mini-hide">Users</span>
                        </Link>
                    </li>
                    <li>
                        <Link to="/organization-accounts">
                            <i className="fa fa-share-alt sidebar-nav-icon"></i>
                            <span className="sidebar-nav-mini-hide">Organisations</span>
                        </Link>
                    </li>
                    <li>
                        <Link to="/logout">
                            <i className="hi hi-off sidebar-nav-icon"></i>
                            <span className="sidebar-nav-mini-hide">Logout</span>
                        </Link>
                    </li>
                </ul>
            </div>
        </div>
        <div id="sidebar-extra-info" className="sidebar-content sidebar-nav-mini-hide">
            <div className="text-center">
                <small>&copy; All in The Loop</small>
            </div>
        </div>
    </div>
);
export default Sidebar;
